
import { useSelector } from "react-redux";

import { RootState } from "../store";

import { InboxPage } from "./inbox/InboxPage"
import { FirstLoginPage } from "./auth/FirstLoginPage";

export const HomePage = () => {

    const { restablecerContrasena } = useSelector( ( state: RootState ) => state.auth );

    return (
        <>
            {
                restablecerContrasena
                ?
                    <FirstLoginPage />
                :
                    <InboxPage />
            }
        </>
    )
}
